'use client';
import { rem } from '@heathmont/moon-utils';
import { redirect } from 'next/navigation';
import LegacyStyledComponentsPage from '~/client/containers/LegacyStyledComponentsPage';
import Placeholder from '~/client/shared/LazyLoad/Placeholder';
import Stack from '~/client/shared/Stack';
import BlogArticleView from './BlogArticleView';
import useBlogArticle from './useBlogArticle';
import RecentArticles from '../../shared/articles/RecentArticles';
import BlogHeader from '../../shared/BlogHeader';
import SubHeaderInfo from '../../shared/SubHeaderInfo';

const BlogArticle: FC = () => {
  const { page, loading, category, breadcrumbs, refetch, handle, site } =
    useBlogArticle();

  if (loading) {
    return <Placeholder height={484} />;
  }

  if (!page && !loading) {
    refetch({
      filter: { site, handle, section: `blog-${category}`, language: 'en' },
    });
    return <Placeholder height={484} />;
  }

  if (!page.id) {
    return redirect('/');
  }

  return (
    <LegacyStyledComponentsPage>
      <Stack maxWidth={rem(1176)} margin="0 auto">
        <BlogHeader headerType="p" />
        <SubHeaderInfo breadcrumbs={breadcrumbs} title={`blog.${category}`} />
        <Stack>
          <BlogArticleView page={page} />
        </Stack>
        <RecentArticles />
      </Stack>
    </LegacyStyledComponentsPage>
  );
};

export default BlogArticle;
